import { EMPLOYEE_LOG, RESET_EMPLOYEE_LOG, EMPLOYEE_LOG_SUMMARY, RESET_EMPLOYEE_LOG_SUMMARY, EMPLOYEE_NAME, RESET_EMPLOYEE_NAME } from "../types"

const employeeLog = (data) => {
    return {
        type: EMPLOYEE_LOG,
        data
    }
}

const resetEmployeeLog = () => {
    return {
        type: RESET_EMPLOYEE_LOG
    }
}

const employeeLogSummary = (summary) => {
    return {
        type: EMPLOYEE_LOG_SUMMARY,
        summary
    }
}

const resetEmployeeLogSummary = () => {
    return {
        type: RESET_EMPLOYEE_LOG_SUMMARY
    }
}

export const employeeName = (data) => ({
    type: EMPLOYEE_NAME,
    data
})

export const resetEmployeeName = () => ({
    type: RESET_EMPLOYEE_NAME
})

export {
    employeeLog,
    resetEmployeeLog,
    employeeLogSummary,
    resetEmployeeLogSummary
}
